<div class="container-fluid">
  <mat-tab-group mat-stretch-tabs>
    <mat-tab
      *ngIf="authService.checkActionsPermission('REMI', ['CREATE'])"
      label="Crear"
      ><ng-template matTabContent
        ><app-remission-form
          [isUpdateOperation]="isUpdateOperation"
          PK="null"
        ></app-remission-form></ng-template
    ></mat-tab>
    <mat-tab
      *ngIf="authService.checkActionsPermission('REMI', ['UPDATE', 'PRINT'])"
      label="Buscar"
      ><ng-template matTabContent
        ><app-remission-search></app-remission-search></ng-template
    ></mat-tab>
    <mat-tab
      *ngIf="authService.checkActionsPermission('REMI', ['REPORT'])"
      label="Informe"
      ><ng-template matTabContent
        ><app-remission-report></app-remission-report></ng-template
    ></mat-tab>
  </mat-tab-group>
</div>
